export default __webpack_public_path__ + "static/media/fitness.268dd9e4.png";